'use strict';

import ngResource from 'angular-resource';

class SaConfigService {
  constructor($resource) {
    'ngInject';
    this.api = $resource(
      '/api/sa_config/:id',
      {id: '@id'},
      {
        index: {method: 'GET', isArray: true},
        show: {method: 'GET', isArray: false},
        update: {method: 'PUT', isArray: false}
      }
    );

    this.oem_api = $resource(
      '/api/oem/sa_config/:id',
      {id: '@id'},
      {
        index: {method: 'GET', isArray: true},
        pageIndex: {method: 'GET', isArray: false},
        show: {method: 'GET', isArray: false},
        create: {method: 'POST', isArray: false},
        update: {method: 'PUT', isArray: false}
      }
    );
  }
}

export default angular.module('leptonApp.SaConfigService', ['ngResource'])
  .service('SaConfigService', ['$resource', SaConfigService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/sa_config/sa_config.service.js